import { useBapApi } from "@/api/useBapApi";
import { useToastTransaction } from "@/composables/useToast/useToastTransaction";
import { guildIndexes } from "@/helpers/utils";
import { useWalletCollectionStore } from "@/store/wallet-collection";
import { useWeb3Store } from "@/store/web3";
import { useOrchestratorContract } from "@/web3/contracts";

export const openGodBox = async (token) => {
  // opening chest
  const web3Store = useWeb3Store();
  const walletAddress = web3Store.walletAddress;
  const guildIndex = guildIndexes.indexOf(token.guild);
  try {
    const { success, result } = await useBapApi({
      throw: true,
      toast: { error: true },
    }).exec({
      url: "/mint/sign/openchest",
      method: "POST",
      data: {
        wallet: walletAddress,
        bull1: token.id,
      },
    });
    if (!success) {
      throw new Error("Unable to sign transaction");
    }
    const contract = useOrchestratorContract(true);
    const { signature, seed, hasPower } = result;

    let gas = await contract.methods
      .openChest(token.id, guildIndex, seed, hasPower, signature)
      .estimateGas({ from: walletAddress });
    gas += 20000;
    const response = await useToastTransaction(
      contract.methods.openChest(
        token.id,
        guildIndex,
        seed,
        hasPower,
        signature
      ),
      {
        sendOptions: {
          gas,
        },
        text: "Opening God Box",
      }
    );
    const winningId = +response.events.CHEST_OPENED.returnValues.prize;

    useWalletCollectionStore().fetchCollection(true);
    useWeb3Store().update()
    return winningId;
  } catch (err) {
    console.log("error", err);
  }
};
